// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__5A4ts","footer":"ModalUpdate_footer__I9t5a"};